const getOptionsByIds = (ids = [], options = []) => {
  const optionsById = new Map(
    options.map((option) => [String(option.id), option]),
  );

  return ids
    .map((id) => optionsById.get(String(id)))
    .filter((option) => option != null);
};

export default getOptionsByIds;
